import React, { useState } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useTranslation } from "../../i18n/useTranslation";

export default function ProfileStep({
  firstName,
  email,
  address,
  promoOptOut,
  onChange,
  onBack,
  onDone,
  onClose,
}) {
  const { t } = useTranslation();
  const [error, setError] = useState("");

  const isValidEmail = (value) => {
    const v = (value || "").trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  };

  const handleContinue = () => {
    const fn = (firstName || "").trim();
    const em = (email || "").trim();
    const ad = (address || "").trim();

    if (!fn) {
      setError(t("first_name_required"));
      return;
    }

    if (!em) {
      setError(t("email_required"));
      return;
    }

    if (!isValidEmail(em)) {
      setError(t("email_invalid"));
      return;
    }

    if (!ad) {
      setError("Adresse requise");
      return;
    }

    setError("");
    onDone?.();
  };

  return (
    <>
      <div className="modal-text-container modal-container">
        <ArrowLeftOutlined className="auth-back" onClick={onBack} />

        <div className="modal-header-container">
          <p className="modal-text-header">
            {t("last_step")}
          </p>
          <p
            className="modal-text-price"
            style={{ cursor: "pointer" }}
            onClick={onClose}
          />
        </div>

        <p className="auth-helper">
          {t("profile_subtitle")}
        </p>

        <input
          className="auth-input"
          value={firstName}
          onChange={(e) => {
            onChange({ firstName: e.target.value });
            setError("");
          }}
          placeholder={t("first_name")}
          autoComplete="given-name"
        />

        <input
          className="auth-input auth-input-bottom"
          value={email}
          onChange={(e) => {
            onChange({ email: e.target.value });
            setError("");
          }}
          placeholder={t("email")}
          inputMode="email"
          autoComplete="email"
        />

        <input
          className="auth-input auth-input-bottom"
          value={address}
          onChange={(e) => {
            onChange({ address: e.target.value });
            setError("");
          }}
          placeholder="7 Rue de Paradis, 75010 Paris"
          autoComplete="street-address"
        />

        <label className="auth-checkbox-row modal-opt-checkbox">
          <input
            type="checkbox"
            checked={promoOptOut}
            onChange={(e) => onChange({ promoOptOut: e.target.checked })}
          />
          <span>{t("no_promotions")}</span>
        </label>

        {error && <p className="auth-error">{error}</p>}
      </div>

      <div className="modal-close-container">
        <div className="modal-close-button" onClick={handleContinue}>
          {t("continue")}
        </div>
      </div>
    </>
  );
}